import React, { useEffect, useState } from 'react';
import LinkifyText from './LinkifyText.js';
import { useParams} from 'react-router-dom';
import { API_BASE_URL } from '../scripts/control';

const TalkDetail = () => {
    const { idtalk } = useParams(); // Obtenida de la URL
    const [talk, setTalk] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/details.php?type=talk&id=${idtalk}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setError(data.error);
                } else {
                    setTalk(data);
                }
            })
            .catch((error) => setError('Error al obtener los detalles del congreso/seminario.'));
    }, [idtalk]);

    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!talk) {
        return <div>Cargando detalles del congreso/seminario...</div>;
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div className="card" style={{ maxWidth: '900px', margin: '20px auto', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
            <div className="card-body m-2">
                <h1 className="card-title">{talk.title}</h1>
                <img
                    src={talk.img_url 
                            ? `${API_BASE_URL}/public/uploads/images/${talk.img_url}`  
                            : `${API_BASE_URL}/public/uploads/images/comic.jpg`}
                    alt={talk.img_alt || 'Imagen del congreso/seminario'}
                    style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', marginBottom: '20px', marginLeft: '-2%' }}
                />
                <LinkifyText text={talk.body} />
                
                {talk.location && (
                    <p className="card-text">
                        <strong>Ubicación:</strong> {talk.location || 'No especificada'}
                    </p>
                )}
                
                {talk.day && talk.day !== '0000-00-00' && (
                    <p className="card-text">
                        <strong>Fecha:</strong> {formatDate(talk.day)}
                    </p>
                )}

                {talk.hour && talk.hour !== '00:00:00' && (
                    <p className="card-text">
                        <strong>Hora:</strong> {talk.hour || 'No especificada'}
                    </p>
                )}

                <button
                    className="btn btn-primary"
                    style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#005EC4', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                     onClick={scrollToTop}
                >
                    Subir
                </button>
            </div>
        </div>
    );
};

export default TalkDetail;
